import { z } from "zod";

export const JoinPathSchema = z.object({
  fromColumn: z.string().min(1),
  toTable: z.string().min(1),
  toColumn: z.string().min(1),
});

export type JoinPath = z.infer<typeof JoinPathSchema>;